import styled from 'styled-components'

const InfoBlock = styled.div`
  padding: var(--info-padding, 32px);
  background-color: var(--color-bg-accent);
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjI0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMzIwIDI0OFY3M2MtNDguOTQ1IDAtOTEuOTE3LTI5LjQzNi0xMDUuNjIyLTczSDB2ODZjMTExLjI2MSAwIDE5MC4wMTMgNzguMjY2IDIwNS41MDQgMTYySDMyMHoiIGZpbGw9IiNGOUZBRkIiLz48L3N2Zz4=');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
`

InfoBlock.Title = styled.h4`
  margin-bottom: var(--info-title-bspace, 52px);
  font-weight: bold;
  font-size: var(--info-title-size, 12px);
  line-height: 1.4;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--info-title-color, var(--color-extra));
`

InfoBlock.Desc = styled.p`
  font-weight: normal;
  font-size: var(--info-desc-size, 20px);
  line-height: 1.4;
  color: var(--info-desc-color, var(--color-main));

  &:not(:last-child) {
    margin-bottom: var(--info-desc-bspace, 18px);
  }
`

export default InfoBlock
